export default "__VITE_ASSET__14613451__"